import { render } from "./SelectUf.vue?vue&type=template&id=3d5053f7&ts=true"
import script from "./SelectUf.vue?vue&type=script&lang=ts"
export * from "./SelectUf.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__